export default "__VITE_ASSET__B7ki2c7E__"